import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ActivityService } from "../activity/service/activity.service";
import { faBook } from "@fortawesome/free-solid-svg-icons/faBook";
import { faGem } from "@fortawesome/free-solid-svg-icons/faGem";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons/faCloudDownloadAlt";
import { faTasks } from "@fortawesome/free-solid-svg-icons/faTasks";
import { faSearchDollar } from "@fortawesome/free-solid-svg-icons/faSearchDollar";
import { TaskState } from "cilor-db-api-shared";
import { faCogs } from "@fortawesome/free-solid-svg-icons/faCogs";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent {
  public groups = [
    {
      title: "Daten",
      entries: [
        {
          title: "Produkte",
          url: "/products",
          icon: faBook,
        },
        {
          title: "Brillanten",
          url: "/brillants",
          icon: faGem,
        },
        {
          title: "Werte",
          url: "/values",
          icon: faFileAlt,
        }
      ]
    },
    {
      title: "Aktionen",
      entries: [
        {
          title: "Upload",
          url: "/upload",
          icon: faCloudUploadAlt,
        },
        {
          title: "Download",
          url: "/download",
          icon: faCloudDownloadAlt,
        },
      ]
    },
    {
      title: "System",
      entries: [
        {
          title: "Aktivität",
          url: "/activity",
          accessory: (): string | null => {
            return this.activityService
              .data?.tasks.filter((task: { state: TaskState }) => {
              return task.state === TaskState.running || task.state === TaskState.pending;
            }).length.toString() ?? null;
          },
          icon: faTasks,
        },
        {
          title: "Preisberechnung",
          url: "/calculator-messages",
          icon: faSearchDollar,
        },
        {
          title: "API",
          url: "/api",
          icon: faCogs,
        },
      ]
    },
  ];

  constructor(
    public readonly router: Router,
    public readonly activityService: ActivityService,
  ) { }

  public navigate(url: string): void {
    this.router.navigate([url]);
  }
}
